export const findOrdersByIds = <T extends { orderId: string }>(
   availableOrders: T[],
   selectedOrdersIds: string[],
) =>
   selectedOrdersIds.map(selectedOrderId =>
      availableOrders.find(availableOrder => availableOrder.orderId === selectedOrderId),
   );
